const { Component, Mixin } = Shopware;
const { object, string: { kebabCase } } = Shopware.Utils;

import template from './coman-consent-manager-configuration.twig';

Component.register('coman-consent-manager-configuration', {
    template,
    props: ['extension'],

    mixins: [
        Mixin.getByName('notification'),
    ],

    inject: ['systemConfigApiService'],

    data(){
        return {
            componentKey: 0,
            inheritedFields: {},
            globalConfig: null,
            schConfig: null,
            domain: 'ComanConsentManager.config',
            popupUrl: null,
            popupWindow: null, // Store reference to the popup
            isLoading: false,
            isSaveSuccessful: false,
            blockingMode: null,
            active : true,
            salesChannelId: null,
            formId: null,
            additionalHtml: null,
            cdn: 'cdn.consentmanager.net',
            host: 'delivery.consentmanager.net',
            options: [
                {
                    id: 'automatic',
                    name: this.$tc('coman.option1'),
                },
                {
                    id: 'manual',
                    name: this.$tc('coman.option2'),
                },
            ],
            errors: {}, // Object to store validation errors
            isInherited: false,
            popupSuccess: false, // Controls success alert visibility
        }
    },

    created(){
        this.createdComponent();
    },

    methods: {
        updateCurrentValue(field, value){
            this.inheritedFields[field] = value;
        },
        getInheritValue(firstKey){
            if(this.salesChannelId){
                let configKey = 'ComanConsentManager.config.'+ firstKey;
                return this.globalConfig[configKey];
            }
            return null;
        },

        async createdComponent(){

            this.isLoading = true;
            try {
                this.setConfiguration();

            } catch (error) {
                if (error?.response?.data?.errors) {
                    this.createErrorNotification(error.response.data.errors);
                }
            } finally {
                this.isLoading = false;
            }
        },
        generatePopupUrl() {
            const baseUrl = 'https://app.consentmanager.net/clientv2/onboarding';
            const domain = window.location.hostname; // Get current domain
            const lang = Shopware.Store.get('session').currentLocale.slice(0, 2); // Get current language
            const type = 'cmp'; // Popup type
            const source = 'shopware'; // Platform identifier

            const params = new URLSearchParams({
                type: type,
                domain: domain,
                lang: lang,
                source: source,
            });

            return `${baseUrl}?${params.toString()}`;
        },

        async setConfiguration() {
            // Fetch global configuration values (null means global)
            const globalConfig = await this.systemConfigApiService.getValues('ComanConsentManager.config', null);
            this.globalConfig = globalConfig;

            this.blockingMode = globalConfig['ComanConsentManager.config.blockingMode'];
            this.active = globalConfig['ComanConsentManager.config.active'];
            this.formId = globalConfig['ComanConsentManager.config.formId'];
            this.cdn = globalConfig['ComanConsentManager.config.cdn'] || 'cdn.consentmanager.net';
            this.host = globalConfig['ComanConsentManager.config.host'] || 'delivery.consentmanager.net';
            this.additionalHtml = globalConfig['ComanConsentManager.config.additionalHtml'];

            // Fetch specific configuration for the selected Sales Channel (SCH)
            const schConfig = await this.systemConfigApiService.getValues('ComanConsentManager.config', this.salesChannelId);
            this.schConfig = schConfig;

            if(this.salesChannelId){
                // Assign values to the fields, falling back to global values if SCH-specific values are empty
                this.blockingMode = schConfig['ComanConsentManager.config.blockingMode'];
                this.active = schConfig['ComanConsentManager.config.active'];
                this.formId = schConfig['ComanConsentManager.config.formId'];
                this.cdn = schConfig['ComanConsentManager.config.cdn'];
                this.host = schConfig['ComanConsentManager.config.host'];
                this.additionalHtml = schConfig['ComanConsentManager.config.additionalHtml'];

            }

            // Compare global and SCH-specific configurations to check if inheritance exists
            this.isInherited = (
                schConfig['ComanConsentManager.config.blockingMode'] === undefined &&
                schConfig['ComanConsentManager.config.active'] === undefined &&
                schConfig['ComanConsentManager.config.formId'] === undefined &&
                schConfig['ComanConsentManager.config.additionalHtml'] === undefined
            );
        },
        // Validate required fields before saving
        validateFields() {
            let isValid = true;

            this.errors = {}; // Reset errors

            if (this.inheritedFields.formId && this.salesChannelId && (this.formId === null || this.formId === undefined )) {
            }else{
                // Validate formId (Code-ID)
                const formIdStr = String(this.formId || '');
                if (formIdStr.trim() === '') {
                    this.errors.formId = this.$tc('coman.error.formIdRequired');
                    isValid = false;
                }
            }


            if (this.inheritedFields.host  && this.salesChannelId && (this.host === null || this.host === undefined) ) {
            }else{
                // Validate host and remove protocol
                if (!this.host || typeof this.host !== 'string' || this.host.trim() === '') {
                    this.errors.host = this.$tc('coman.error.hostRequired');
                    isValid = false;
                } else {
                    this.host = this.removeProtocol(this.host);
                }
            }

            if (this.inheritedFields.cdn  && this.salesChannelId && (this.cdn === null || this.cdn === undefined) ) {
            }else{
                // Validate CDN and remove protocol
                if (!this.cdn || typeof this.cdn !== 'string' || this.cdn.trim() === '') {
                    this.errors.cdn = this.$tc('coman.error.cdnRequired');
                    isValid = false;
                } else {
                    this.cdn = this.removeProtocol(this.cdn);
                }
            }


            return isValid;
        },
        // Helper method to remove protocol (http:// or https://) from URLs
        removeProtocol(url) {
            return url.replace(/^(https?:\/\/)/, '');
        },

        async onSave() {
            this.isLoading = true;

            // Validate fields before saving
            if (!this.validateFields()) {
                this.createNotificationError({
                    message: this.$tc('coman.error.validationFailed'),
                });
                this.isLoading = false;
                return;
            }

            // Build the configuration object dynamically
            const newConfig = {
                'ComanConsentManager.config.blockingMode': this.blockingMode,
                'ComanConsentManager.config.active': this.active,
                'ComanConsentManager.config.formId': this.formId,
                'ComanConsentManager.config.cdn': this.cdn,
                'ComanConsentManager.config.host': this.host,
                'ComanConsentManager.config.additionalHtml': this.additionalHtml,
            };

            try {
                // Save the configuration for the selected Sales Channel
                await this.systemConfigApiService.saveValues(newConfig, this.salesChannelId);

                // Notify success and reset state
                this.createNotificationSuccess({
                    message: this.$tc('coman.message'),
                });
                this.isSaveSuccessful = true;
            } catch (error) {
                // Handle save error
                this.createNotificationError({
                    message: this.$tc('coman.error.saveFailed'),
                });
                console.error('Error saving configuration:', error);
            } finally {
                this.isLoading = false;
                // Reset the popup success message
                this.popupSuccess = false;
            }
        },
        onSaveFinish() {
            this.isSaveSuccessful = false;
        },

        onChangeType(value, notification = false) {

            this.blockingMode = value;
            if(notification){

                this.configuration['ComanConsentManager.config.blockingMode'] = this.blockingMode;

                this.onSave();
            }
        },

        onSalesChannelChanged(value){
            this.salesChannelId = value;
            // Reset the popup success message
            this.popupSuccess = false;
            this.setConfiguration();

            this.componentKey++
        },
        openConsentPopup() {
            if (this.popupWindow && !this.popupWindow.closed) {
                this.popupWindow.focus();
                return;
            }
            this.popupUrl = this.generatePopupUrl();

            // Open the popup window
            this.popupWindow = window.open(this.popupUrl, '_blank', 'width=800,height=400');

            // Listen for messages from the popup
            window.addEventListener('message', this.handlePopupMessage);
        },
        handlePopupMessage(event) {
            const allowedOrigin = 'https://app.consentmanager.net'; // Verify the origin

            // Verify the origin of the message
            if (event.origin !== allowedOrigin) {
                console.warn('Received message from untrusted origin:', event.origin);
                return;
            }

            // Parse and validate the data format
            try {
                const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

                if (!data || typeof data !== 'object') {
                    console.error('Invalid message format:', data);
                    return;
                }

                this.processPopupData(data, event);
            } catch (error) {
                console.error('Error processing message data:', error);
            }
        },
        processPopupData(data, event) {
            // Handle the data returned from the popup
            if (data.type === 'cmpcodes') {
                if (data.codeid) {
                    this.formId = data.codeid;
                }
                if (data.cdn) {
                    this.cdn = data.cdn;
                }
                if (data.host) {
                    this.host = data.host;
                }
                if (data.blocking) {
                    const blockingMode = data.blocking === 'semi-automatic' ? 'manual' : data.blocking;
                    this.blockingMode = blockingMode;
                }

                // Notify success after data is inserted
                this.popupSuccess = true;

                // Close popup
                event.source.postMessage({ action: 'closeonboarding' }, event.origin);
            } else {
                console.warn('Unexpected data type received or missing required fields:', data);
            }
        },
        createErrorNotification(errors) {
            let message = `<div>${this.$tc(
                'sw-config-form-renderer.configLoadErrorMessage',
                errors.length,
            )}</div><ul>`;

            errors.forEach((error) => {
                message = `${message}<li>${error.detail}</li>`;
            });
            message += '</ul>';

            this.createNotificationError({
                message: message,
                autoClose: false,
            });
        },
    },
    beforeDestroy() {
        // Clean up the event listener to prevent memory leaks
        window.removeEventListener('message', this.handlePopupMessage);
    },
});
